let CloseButton = function (props) {
  let {
    size = 16,
    color = "#000",
    enabled = true,
    onClick
  } = props;

  return (
    <button disabled={!enabled} tabIndex="0" className="mc-icon-button" aria-label="Close" onClick={onClick}>
      <svg viewBox="0 0 100 100" width={size} height={size}>
        <line
          stroke={color}
          strokeWidth="18"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="13.8"
          y1="13.8"
          x2="86.2"
          y2="86.2"/>
        <line
          stroke={color}
          strokeWidth="18"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="13.8"
          y1="86.2"
          x2="86.2"
          y2="13.8"/>
      </svg>
    </button>
  );
};

module.exports = CloseButton;